import React, { ReactNode } from 'react'
import logoImg from 'resources/images/logo.png'

type Props = {
  showText?: boolean
}

export default function Logo({ showText }: Props) {
  return (
    <div className='logo'>
      <img src={logoImg} alt="" />
      {showText ? "Homie AI" : ""}
    </div>
  )
}

export function LogoWithText({ showText }: Props) {
  return (
    <div className={'logo has-text'}>
      <img src={logoImg} alt="" />
      {showText ? "Homie AI" : ""}
    </div>
  )
}